var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173 177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.7,90.7c-15.1,0-28.3,7.3-35.2,18.1s.7,7.5,5.1,7.5h0c2.1,0,4-1,5-2.6,4.9-7.7,14.3-12.9,25-12.9s20.1,5.2,25,12.9,2.9,2.6,5,2.6h0c4.4,0,7.2-4.1,5.1-7.5-6.9-10.8-20-18.1-35.2-18.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.5,7.7C41.4,7.7,4.8,44.3,4.8,89.4s36.6,81.7,81.7,81.7,81.7-36.6,81.7-81.7S131.6,7.7,86.5,7.7ZM87.5,156.6c-37.1,0-67.2-30.1-67.2-67.2S50.4,22.2,87.5,22.2s67.2,30.1,67.2,67.2-30.1,67.2-67.2,67.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68,
    cy: 67,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 109.8,
    cy: 67,
    r: 9.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadface);
export default __webpack_public_path__ + "static/media/sadface.7bd04e59ddafcb3ad1ca402a4b4e6fac.svg";
export { ForwardRef as ReactComponent };